
import template from "../../lib/plugin/template.js"

template(window._hyperscript)

